import TarjetaAperturaPlan from '../../components/PlanPago/TarjetaAperturaPlan';
import { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import EventoService from '../../services/eventoService';
import NotificacionService from '../../services/notificacionService';
import CrearEventoModal from '../../components/CrearEventoModal';
import ChecklistTramite from '../../components/Tramite/ChecklistTramite';
import BotonCancelarReactivarTramite from '../../components/Tramite/BotonCancelarReactivarTramite';
import TarjetaCobroTramite from '../../components/Cobranzas/TarjetaCobroTramite';
import SeccionCobranzaTramite from '../../components/Cobranzas/SeccionCobranzaTramite';
import HistorialTramite from '../../components/HistorialTramite';
import PanelAccionesAvanzadasTramite from '../../components/Administracion/PanelAccionesAvanzadasTramite';
import BannerEstadoFinal from '../../components/BannerEstadoFinal';
import InputMonto from '../../components/InputMonto';
import WhatsAppHeaderButton from '../../components/WhatsAppHeaderButton';
import PanelUbicacionTramite from '../../components/PanelUbicacionTramite';
import FeedbackButton from '../../components/FeedbackButton';
import NotaComentario from '../../components/NotaComentario';
import TarjetaTurnoAnses from '../../components/TarjetaTurnoAnses';
import ExpedientesAnsesTramite, { enSeguimientoDeExpediente } from '../../components/ExpedientesAnsesTramite';
import useCustomModal from '../../hooks/useCustomModal';
import useVolverAtras from '../../hooks/useVolverAtras';
import CustomModal from '../../components/CustomModal';
import { useAuth } from '../../auth/AuthContext';
import { ModalCrearTurno } from '../Recepcion/TurneroPage';
import turneroStyles from '../../style/pages/Turnero.module.css';
import { getTramitePlanPagoById, actualizarChecklistItem, actualizarTramitePlanPago, actualizarComentariosPlanPago, agregarCompraPlanPago, eliminarCompraPlanPago } from '../../services/planPagoService';
import { getTramitesJubilacion } from '../../services/jubilacionService';
import { actualizarActaHijo } from '../../services/actaHijoService';
import { subirArchivo, descargarArchivo, obtenerArchivosPorTramite, eliminarArchivo } from '../../services/archivoService';
import CardReconocimientosServicios from '../../components/Reconocimiento/CardReconocimientosServicios';
import PanelTramitesRelacionados from '../../components/Tramite/PanelTramitesRelacionados';
import BotonGenerarCaratula from '../../components/Caratula/BotonGenerarCaratula';
import { rutaIniciarTramite } from '../../utils/rutasTramite';
import { apellidoNombre } from '../../utils/nombrePersona';
import EtiquetaTramite from '../../components/EtiquetaTramite';

// Deriva la edad a partir de la fecha de nacimiento (YYYY-MM-DD); sin fecha, sin edad.
const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return '';
    const hoy = new Date();
    const nac = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nac.getFullYear();
    const m = hoy.getMonth() - nac.getMonth();
    if (m < 0 || (m === 0 && hoy.getDate() < nac.getDate())) edad--;
    return edad >= 0 ? edad : '';
};

// Clase del badge contador (X/Y): verde cuando está completo, gris en caso contrario.
const claseBadgeContador = (completados, total) => (total > 0 && completados === total ? 'bg-success' : 'bg-secondary');

const formatLocalFecha = (fechaInput) => {
    if (!fechaInput) return '';
    if (typeof fechaInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fechaInput)) return fechaInput;
    const d = new Date(fechaInput);
    if (Number.isNaN(d.getTime())) return '';
    return new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
};

/** Panel destacado de resumen de aportes. Hoy resumenAportes llega vacío (stub del backend);
 * la Calculadora de Aportes conecta los valores reales sin tocar este componente. */
function PanelResumenAportes({ resumen }) {
    const r = resumen || {};
    const comprados = r.mesesComprados;
    const faltantes = r.mesesFaltantes; // "restantes" (a comprar − comprados)
    const totales = r.mesesTotales;     // "a comprar" (viene de la calculadora)
    const fechaLimite = r.fechaLimite;
    const sinDatos = totales == null && (comprados == null || comprados === 0) && faltantes == null;

    const porcentaje = (totales != null && totales > 0 && comprados != null)
        ? Math.min(100, Math.round((comprados / totales) * 100))
        : null;

    const fechaLimiteDate = fechaLimite ? new Date(fechaLimite) : null;
    const proximaAVencer = fechaLimiteDate && !Number.isNaN(fechaLimiteDate.getTime())
        && (fechaLimiteDate.getTime() - Date.now()) < 1000 * 60 * 60 * 24 * 30;

    const tile = (titulo, valor, gradiente, icono, colorTexto = 'white') => (
        <div className="col-md-3">
            <div className="card shadow-sm h-100" style={{ border: 'none', borderRadius: '12px', background: gradiente }}>
                <div className="card-body" style={{ padding: '1.25rem' }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div style={{ color: colorTexto }}>
                            <div style={{ fontSize: '0.78rem', opacity: 0.9, marginBottom: '0.3rem', fontWeight: 600 }}>{titulo}</div>
                            <div style={{ fontSize: '1.75rem', fontWeight: 700 }}>{valor}</div>
                        </div>
                        <i className={`bi ${icono}`} style={{ fontSize: '2.25rem', color: 'rgba(255,255,255,0.35)' }}></i>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="row g-4 mt-1">
            <div className="col-12">
                <div className="card shadow-lg border-0 rounded-4 p-4">
                    <h4 className="fw-bold text-primary mb-3">
                        <i className="bi bi-calculator me-2"></i>Resumen de Aportes — Plan de Pago
                    </h4>

                    <div className="row g-3">
                        {tile('MESES A COMPRAR', totales ?? '—', 'var(--gradient-danger)', 'bi-cart-plus')}
                        {tile('MESES COMPRADOS', comprados ?? '—', 'var(--success-solid)', 'bi-check2-circle')}
                        {tile('MESES RESTANTES', faltantes ?? '—', 'var(--primary)', 'bi-hourglass-split')}
                        <div className="col-md-3">
                            <div className="card shadow-sm h-100" style={{ border: `2px solid ${proximaAVencer ? '#ef4444' : '#e5e7eb'}`, borderRadius: '12px', background: 'white' }}>
                                <div className="card-body" style={{ padding: '1.25rem' }}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div style={{ color: proximaAVencer ? '#dc2626' : '#374151' }}>
                                            <div style={{ fontSize: '0.78rem', marginBottom: '0.3rem', fontWeight: 600, color: '#6b7280' }}>FECHA LÍMITE</div>
                                            <div style={{ fontSize: '1.25rem', fontWeight: 700 }}>
                                                {fechaLimiteDate && !Number.isNaN(fechaLimiteDate.getTime()) ? fechaLimiteDate.toLocaleDateString('es-ES') : '—'}
                                            </div>
                                        </div>
                                        <i className="bi bi-calendar-event" style={{ fontSize: '2.25rem', color: proximaAVencer ? '#fca5a5' : '#cbd5e1' }}></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {porcentaje != null ? (
                        <div className="mt-3">
                            <div className="d-flex justify-content-between mb-1">
                                <small className="text-muted fw-semibold">Progreso comprado</small>
                                <small className="text-muted fw-semibold">{porcentaje}%</small>
                            </div>
                            <div className="progress" style={{ height: '10px', borderRadius: '6px' }}>
                                <div className="progress-bar bg-success" role="progressbar" style={{ width: `${porcentaje}%` }}></div>
                            </div>
                        </div>
                    ) : (
                        sinDatos && (
                            <div className="alert alert-secondary border-0 rounded-3 mt-3 mb-0 text-center">
                                <i className="bi bi-hourglass-split me-2"></i>Pendiente de conexión con la Calculadora de Aportes
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
}

/** Compras de meses (cantidad + monto + fecha) cargadas a mano; suma = "meses comprados". */
function PanelComprasMeses({ idTramite, compras, onCambio }) {
    const [cantidad, setCantidad] = useState('');
    const [monto, setMonto] = useState('');
    const [guardando, setGuardando] = useState(false);
    const [error, setError] = useState(null);

    const lista = Array.isArray(compras) ? compras : [];
    const totalComprado = lista.reduce((acc, c) => acc + (Number(c.cantidadMeses) || 0), 0);
    const totalMonto = lista.reduce((acc, c) => acc + (Number(c.monto) || 0), 0);

    const handleAgregar = async () => {
        const cant = parseInt(cantidad, 10);
        if (!(cant > 0)) { setError('La cantidad de meses debe ser mayor a 0.'); return; }
        setGuardando(true);
        setError(null);
        try {
            await agregarCompraPlanPago(idTramite, { cantidadMeses: cant, monto: monto === '' ? null : Number(monto) });
            setCantidad('');
            setMonto('');
            if (onCambio) await onCambio();
        } catch (e) {
            setError(e.response?.data || 'No se pudo agregar la compra.');
        } finally {
            setGuardando(false);
        }
    };

    const handleEliminar = async (idCompra) => {
        try {
            await eliminarCompraPlanPago(idCompra);
            if (onCambio) await onCambio();
        } catch {
            setError('No se pudo eliminar la compra.');
        }
    };

    const fmtMonto = (m) => (m == null ? '—' : `$ ${Number(m).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
    const fmtFecha = (f) => { const d = f ? new Date(f) : null; return d && !Number.isNaN(d.getTime()) ? d.toLocaleDateString('es-ES') : '—'; };

    return (
        <div className="row g-4 mt-1">
            <div className="col-12">
                <div className="card shadow-lg border-0 rounded-4 p-4">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-1">
                        <h4 className="fw-bold text-primary mb-0">
                            <i className="bi bi-cart-check me-2"></i>Compras de Meses
                        </h4>
                        {lista.length > 0 && (
                            <span className="badge bg-success bg-opacity-10 text-success border border-success-subtle rounded-pill fs-6 px-3">
                                <i className="bi bi-check2-circle me-1"></i>
                                {totalComprado} {totalComprado === 1 ? 'mes comprado' : 'meses comprados'}
                            </span>
                        )}
                    </div>
                    <p className="text-muted small mb-4">Registrá cada pago de meses del Plan de Pago 27.705. El total se refleja automáticamente en el Resumen de Aportes.</p>

                    {/* Registrar nueva compra */}
                    <div className="rounded-4 p-3 p-md-4 mb-4" style={{ background: 'var(--teal-bg)', border: '1px solid #bbf7d0' }}>
                        <h6 className="fw-bold mb-3" style={{ color: '#15803d' }}>
                            <i className="bi bi-plus-circle me-2"></i>Registrar nueva compra
                        </h6>
                        <div className="row g-3 align-items-end">
                            <div className="col-md-4">
                                <label className="form-label small fw-semibold text-muted mb-1">Cantidad de meses</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-white"><i className="bi bi-calendar-month"></i></span>
                                    <input type="number" min="1" className="form-control" value={cantidad}
                                        onChange={(e) => setCantidad(e.target.value)} placeholder="Ej: 12" />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label small fw-semibold text-muted mb-1">Monto pagado</label>
                                <InputMonto value={monto} onChange={setMonto} placeholder="Opcional" />
                            </div>
                            <div className="col-md-4">
                                <button
                                    className="btn w-100 rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2"
                                    style={{ background: 'var(--success-solid)', color: 'white', border: 'none', padding: '0.55rem 0' }}
                                    onClick={handleAgregar} disabled={guardando}>
                                    {guardando
                                        ? <span className="spinner-border spinner-border-sm" role="status"></span>
                                        : <><i className="bi bi-plus-lg"></i>Registrar compra</>}
                                </button>
                            </div>
                        </div>
                        {error && (
                            <div className="alert alert-danger py-2 mb-0 mt-3 rounded-3">
                                {typeof error === 'string' ? error : 'Error al guardar la compra.'}
                            </div>
                        )}
                    </div>

                    {/* Listado de compras */}
                    {lista.length === 0 ? (
                        <div className="alert alert-info border-0 rounded-3 text-center mb-0">
                            <i className="bi bi-info-circle me-2"></i>Todavía no se registraron compras de meses.
                        </div>
                    ) : (
                        <div className="border rounded-4 overflow-hidden">
                            <div className="table-responsive">
                                <table className="table table-hover align-middle mb-0">
                                    <thead>
                                        <tr className="text-uppercase small text-muted" style={{ background: '#f8fafc' }}>
                                            <th className="ps-3 py-3">Fecha</th>
                                            <th className="text-end py-3">Meses</th>
                                            <th className="text-end py-3">Monto</th>
                                            <th className="text-end pe-3 py-3"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lista.map((c) => (
                                            <tr key={c.id}>
                                                <td className="ps-3">
                                                    <i className="bi bi-calendar-event text-muted me-2"></i>{fmtFecha(c.fechaCompra)}
                                                </td>
                                                <td className="text-end">
                                                    <span className="badge rounded-pill" style={{ background: '#dbeafe', color: '#1e40af' }}>{c.cantidadMeses}</span>
                                                </td>
                                                <td className="text-end fw-semibold" style={{ color: '#16a34a' }}>{fmtMonto(c.monto)}</td>
                                                <td className="text-end pe-3">
                                                    <button className="btn btn-sm btn-outline-danger rounded-circle d-inline-flex align-items-center justify-content-center"
                                                        style={{ width: '32px', height: '32px', padding: 0 }}
                                                        onClick={() => handleEliminar(c.id)} title="Eliminar compra">
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="fw-bold" style={{ background: '#f8fafc' }}>
                                            <td className="ps-3">Total</td>
                                            <td className="text-end">{totalComprado}</td>
                                            <td className="text-end" style={{ color: '#16a34a' }}>{fmtMonto(totalMonto)}</td>
                                            <td className="pe-3"></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

function VistaDetalladaTramitePlanPago() {
    const { idTramite } = useParams();
    const navigate = useNavigate();
    const volverAtras = useVolverAtras('/tramites');
    const { user } = useAuth();
    const { modalState, hideModal, showModal } = useCustomModal();

    const [tramite, setTramite] = useState(null);
    const [loading, setLoading] = useState(true);
    // Si el turno ANSES ya tiene resultado: decide si los módulos del plan van antes o después de él.
    const [turnoConResultado, setTurnoConResultado] = useState(false);

    // Edición de datos del trámite (no el cliente ni los hijos)
    const [editMode, setEditMode] = useState(false);
    const [tramiteEdit, setTramiteEdit] = useState(null);
    const [guardandoDatos, setGuardandoDatos] = useState(false);

    // Herramienta: crear turno prellenado con los datos del cliente del trámite
    const [mostrarModalTurno, setMostrarModalTurno] = useState(false);

    const [eventos, setEventos] = useState([]);
    const [cargandoEventos, setCargandoEventos] = useState(true);
    const [mostrarModalEvento, setMostrarModalEvento] = useState(false);
    const [fechaSeleccionadaEvento, setFechaSeleccionadaEvento] = useState(new Date());

    const [modalHistorialAbierto, setModalHistorialAbierto] = useState(false);
    const [subiendoItem, setSubiendoItem] = useState(null);
    const [subiendoActaHijo, setSubiendoActaHijo] = useState(null);

    // Archivos del trámite (fuente única: el checklist enlaza por idArchivo; "otros" son los no vinculados)
    const [archivos, setArchivos] = useState([]);
    const [subiendoGeneral, setSubiendoGeneral] = useState(false);

    // Jubilaciones del mismo cliente (detección por CUIL, sin FK entre módulos)
    const [jubilacionesRelacionadas, setJubilacionesRelacionadas] = useState([]);
    const [cargandoRelacionados, setCargandoRelacionados] = useState(false);

    const recargarTramite = useCallback(async () => {
        try {
            const data = await getTramitePlanPagoById(idTramite);
            setTramite(data);
        } catch (error) {
            console.error('Error al cargar trámite de Plan de Pago:', error);
        }
    }, [idTramite]);

    const recargarArchivos = useCallback(async () => {
        try {
            const data = await obtenerArchivosPorTramite(idTramite);
            setArchivos(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error al cargar archivos:', error);
        }
    }, [idTramite]);

    const recargarEventos = useCallback(async () => {
        try {
            const response = await EventoService.getEventosPorTramite(idTramite);
            setEventos(response.data || []);
        } catch (error) {
            console.error('Error recargando eventos:', error);
        }
    }, [idTramite]);

    // Cargar o cancelar un turno ANSES mueve el estado del trámite del lado del backend
    // (TurnoAnsesService.moverEstadoTramite), así que no alcanza con recargar los eventos:
    // sin recargar la carpeta, el badge de estado y el banner de cierre quedan viejos hasta un F5.
    const refrescarPorTurnoAnses = useCallback(async () => {
        await Promise.all([recargarTramite(), recargarEventos()]);
    }, [recargarTramite, recargarEventos]);

    useEffect(() => {
        const cargar = async () => {
            setLoading(true);
            setCargandoEventos(true);
            try {
                const [tramiteResult, eventosResult, archivosResult] = await Promise.allSettled([
                    getTramitePlanPagoById(idTramite),
                    EventoService.getEventosPorTramite(idTramite),
                    obtenerArchivosPorTramite(idTramite),
                ]);
                setTramite(tramiteResult.status === 'fulfilled' ? tramiteResult.value : null);
                setEventos(eventosResult.status === 'fulfilled' ? (eventosResult.value.data || []) : []);
                setArchivos(archivosResult.status === 'fulfilled' && Array.isArray(archivosResult.value) ? archivosResult.value : []);
            } finally {
                setLoading(false);
                setCargandoEventos(false);
            }
        };
        cargar();
    }, [idTramite]);

    // Auto-refresco de eventos (paridad con ART/RTI/Jubilación/PUAM)
    useEffect(() => {
        const handleEventoCreado = () => recargarEventos();
        window.addEventListener('eventoCreadoDesdeChat', handleEventoCreado);
        const interval = setInterval(() => recargarEventos(), 30000);
        return () => {
            window.removeEventListener('eventoCreadoDesdeChat', handleEventoCreado);
            clearInterval(interval);
        };
    }, [recargarEventos]);

    // Trámites relacionados del cliente: Jubilaciones con el mismo CUIL.
    // Detección pura (no hay FK), así que solo se dispara cuando ya conocemos el CUIL del cliente.
    const cuilCliente = tramite?.cliente?.cuil;
    useEffect(() => {
        if (!cuilCliente) { setJubilacionesRelacionadas([]); return; }
        let cancelado = false;
        setCargandoRelacionados(true);
        getTramitesJubilacion(cuilCliente)
            .then((data) => { if (!cancelado) setJubilacionesRelacionadas(Array.isArray(data) ? data : []); })
            .catch((error) => {
                console.error('Error al buscar Jubilaciones relacionadas:', error);
                if (!cancelado) setJubilacionesRelacionadas([]);
            })
            .finally(() => { if (!cancelado) setCargandoRelacionados(false); });
        return () => { cancelado = true; };
    }, [cuilCliente]);

    const handleGuardarEvento = async (evento) => {
        try {
            const responseEvento = await EventoService.crearEvento({
                ...evento,
                fecha: formatLocalFecha(evento.fecha),
                idTramite: Number(idTramite),
            });
            const idEventoCreado = responseEvento.data.idEvento || responseEvento.data;
            if (evento.tiemposRecordatorio && evento.tiemposRecordatorio.length > 0) {
                await NotificacionService.programarNotificacionesAutomaticas(idEventoCreado, evento.tiemposRecordatorio);
            }
            window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', { detail: { timestamp: Date.now(), source: 'tramite-plan-pago' } }));
            await recargarEventos();
            setMostrarModalEvento(false);
            toast.success('Evento creado correctamente');
        } catch (error) {
            console.error('Error al crear evento:', error);
            toast.error('Error al crear el evento');
        }
    };

    const formatearFechaEvento = (fechaString) => {
        if (!fechaString) return '';
        const [y, m, d] = fechaString.split('T')[0].split('-');
        return `${d}/${m}/${y}`;
    };

    // ---- Descarga con nombre real (extensión + tipo correctos) ----
    const descargarPorId = async (idArchivo) => {
        try {
            const meta = archivos.find(a => a.idArchivo === idArchivo);
            const nombre = meta?.nombre || `archivo_${idArchivo}`;
            const resp = await descargarArchivo(idArchivo);
            const blob = meta?.tipo ? new Blob([resp.data], { type: meta.tipo }) : new Blob([resp.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = nombre;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Error al descargar archivo:', err);
            toast.error('No se pudo descargar el archivo');
        }
    };

    // ---- Checklist ----
    const togglePresentado = async (item) => {
        if (item.idArchivo) return; // con archivo adjunto, el ítem queda marcado y bloqueado
        try {
            await actualizarChecklistItem(item.id, { presentado: !item.presentado, idArchivo: null });
            recargarTramite();
        } catch (err) {
            console.error('Error al actualizar checklist:', err);
        }
    };
    const adjuntarArchivo = async (item, file) => {
        if (!file) return;
        setSubiendoItem(item.id);
        try {
            const resp = await subirArchivo(idTramite, file);
            const idArchivo = resp?.idArchivo ?? null;
            await actualizarChecklistItem(item.id, { presentado: true, idArchivo });
            await Promise.all([recargarTramite(), recargarArchivos()]);
        } catch (err) {
            console.error('Error al adjuntar archivo:', err);
            toast.error('No se pudo adjuntar el archivo');
        } finally {
            setSubiendoItem(null);
        }
    };
    const quitarAdjunto = (item) => {
        showModal({
            title: 'Eliminar documento',
            type: 'warning',
            showCancel: true,
            confirmText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            confirmVariant: 'warning',
            message: `¿Seguro que querés eliminar el archivo adjunto de "${item.nombre}"?`,
            onConfirm: async () => {
                try {
                    await eliminarArchivo(item.idArchivo);
                    await actualizarChecklistItem(item.id, { presentado: false, idArchivo: null });
                    await Promise.all([recargarTramite(), recargarArchivos()]);
                    toast.info('Documento eliminado');
                } catch (err) {
                    console.error('Error al eliminar documento:', err);
                    toast.error('No se pudo eliminar el documento');
                }
            },
        });
    };

    // ---- Acta de nacimiento por hijo (mecanismo compartido con Jubilación) ----
    const togglePresentadaActa = async (hijo) => {
        if (hijo.idArchivoActa) return; // con archivo adjunto, queda marcado y bloqueado
        try {
            await actualizarActaHijo(idTramite, hijo.idHijo, { presentado: !hijo.actaPresentada, idArchivo: null });
            recargarTramite();
        } catch (err) {
            console.error('Error al actualizar acta de nacimiento:', err);
        }
    };
    const adjuntarActa = async (hijo, file) => {
        if (!file) return;
        setSubiendoActaHijo(hijo.idHijo);
        try {
            const resp = await subirArchivo(idTramite, file);
            const idArchivo = resp?.idArchivo ?? null;
            await actualizarActaHijo(idTramite, hijo.idHijo, { presentado: true, idArchivo });
            await Promise.all([recargarTramite(), recargarArchivos()]);
        } catch (err) {
            console.error('Error al adjuntar acta de nacimiento:', err);
            toast.error('No se pudo adjuntar el acta de nacimiento');
        } finally {
            setSubiendoActaHijo(null);
        }
    };
    const quitarActaAdjunta = (hijo) => {
        showModal({
            title: 'Eliminar acta de nacimiento',
            type: 'warning',
            showCancel: true,
            confirmText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            confirmVariant: 'warning',
            message: `¿Seguro que querés eliminar el acta de nacimiento adjuntada de "${hijo.nombre || 'este hijo'}"?`,
            onConfirm: async () => {
                try {
                    await eliminarArchivo(hijo.idArchivoActa);
                    await actualizarActaHijo(idTramite, hijo.idHijo, { presentado: false, idArchivo: null });
                    await Promise.all([recargarTramite(), recargarArchivos()]);
                    toast.info('Acta de nacimiento eliminada');
                } catch (err) {
                    console.error('Error al eliminar acta de nacimiento:', err);
                    toast.error('No se pudo eliminar el acta de nacimiento');
                }
            },
        });
    };

    // ---- Otros documentos (no vinculados al checklist) ----
    const subirGeneral = async (file) => {
        if (!file) return;
        setSubiendoGeneral(true);
        try {
            await subirArchivo(idTramite, file);
            await recargarArchivos();
            toast.success('Archivo subido');
        } catch (err) {
            console.error('Error al subir archivo:', err);
            toast.error('No se pudo subir el archivo');
        } finally {
            setSubiendoGeneral(false);
        }
    };
    const eliminarGeneral = (idArchivo) => {
        showModal({
            title: 'Eliminar archivo',
            type: 'warning',
            showCancel: true,
            confirmText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            confirmVariant: 'warning',
            message: '¿Seguro que querés eliminar este archivo? Esta acción no se puede deshacer.',
            onConfirm: async () => {
                try {
                    await eliminarArchivo(idArchivo);
                    await recargarArchivos();
                    toast.info('Archivo eliminado');
                } catch (err) {
                    console.error('Error al eliminar archivo:', err);
                    toast.error('No se pudo eliminar el archivo');
                }
            },
        });
    };

    // ---- Comentarios (nota editable con firma, igual que ART/RTI/Jubilación/PUAM) ----
    const handleGuardarComentario = async (nuevoComentario) => {
        try {
            await actualizarComentariosPlanPago(idTramite, nuevoComentario);
            await recargarTramite();
            toast.success('Comentario actualizado correctamente');
        } catch (error) {
            console.error('Error al guardar comentario:', error);
            toast.error('No se pudo guardar el comentario');
            throw error;
        }
    };

    // ---- Editar datos del trámite ----
    // aportesProvinciaNoTransferida es el único campo que puede alterar el checklist
    // (agrega/quita RECON_SERVICIOS) → puede requerir confirmación de regeneración (como Jubilación).
    const handleModificar = () => {
        setTramiteEdit({
            organismo: tramite.organismo || '',
            altaMonotributoRealizada: !!tramite.altaMonotributoRealizada,
            aportesProvinciaNoTransferida: !!tramite.aportesProvinciaNoTransferida,
            etiqueta: tramite.etiqueta || '',
        });
        setEditMode(true);
    };
    const handleGuardarDatos = async (confirmarRegenerarChecklist = false) => {
        setGuardandoDatos(true);
        try {
            await actualizarTramitePlanPago(idTramite, {
                ...tramiteEdit,
                organismo: tramiteEdit.organismo || null,
                confirmarRegenerarChecklist,
            });
            await recargarTramite();
            setEditMode(false);
            toast.success('Datos del trámite actualizados');
        } catch (error) {
            if (error.response?.status === 409 && error.response?.data?.requiereConfirmacion) {
                const items = error.response.data.items || [];
                showModal({
                    title: 'Confirmar cambios en el checklist',
                    type: 'warning',
                    showCancel: true,
                    confirmText: 'Sí, continuar',
                    cancelText: 'Cancelar',
                    confirmVariant: 'warning',
                    message: (
                        <div>
                            <p>Con estos cambios, los siguientes formularios del checklist dejan de requerirse, pero ya tienen un archivo adjunto:</p>
                            <ul className="mb-2">
                                {items.map((it) => (
                                    <li key={it.id}>
                                        <strong>{it.nombre}</strong> — archivo: {it.nombreArchivo || `#${it.idArchivo}`}
                                    </li>
                                ))}
                            </ul>
                            <p className="mb-0">El archivo no se elimina: va a quedar disponible en "Otros documentos". ¿Confirmás continuar?</p>
                        </div>
                    ),
                    onConfirm: () => handleGuardarDatos(true),
                });
            } else {
                console.error('Error al guardar datos:', error);
                toast.error(error.response?.data || 'No se pudieron guardar los datos');
            }
        } finally {
            setGuardandoDatos(false);
        }
    };

    const verDetalleCliente = (cuil) => navigate(`/clientes/vista-detallada/${cuil.toString()}`);

    if (loading) {
        return (
            <div className="text-center my-5">
                <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }}></div>
                <p className="mt-3 fw-semibold" style={{ color: '#6B7280' }}>Cargando trámite...</p>
            </div>
        );
    }
    if (!tramite) {
        return <div className="alert alert-danger mt-4">No se encontró el trámite.</div>;
    }

    const cliente = tramite.cliente || {};
    const formularios = tramite.formularios || [];
    const hijos = tramite.hijos || [];
    const idsEnChecklist = new Set([
        ...formularios.map(f => f.idArchivo).filter(Boolean),
        ...hijos.map(h => h.idArchivoActa).filter(Boolean),
    ]);
    const archivosOtros = archivos.filter(a => !idsEnChecklist.has(a.idArchivo));
    const nombrePorId = archivos.reduce((acc, a) => { acc[a.idArchivo] = a.nombre; return acc; }, {});
    const formatTamano = (bytes) => (bytes == null ? '' : (bytes / (1024 * 1024)).toFixed(2) + ' MB');

    // Los módulos propios del plan de pago: lo primero que se mira del trámite.
    const modulosPlanPago = (
        <>
            <PanelResumenAportes resumen={tramite.resumenAportes} />
            <PanelComprasMeses idTramite={tramite.idTramite} compras={tramite.compras} onCambio={recargarTramite} />
            <TarjetaAperturaPlan tramite={tramite} onCambio={recargarTramite} />
        </>
    );

    return (
        <div className="container mt-4">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-start mb-4">
                <div style={{ flex: '1 1 20rem', minWidth: 0 }}>
                    <div className="d-flex align-items-center flex-wrap gap-3 mb-1">
                        <h2 className="fw-bold text-primary mb-0">Detalles del Trámite de Plan de Pago 27.705</h2>
                        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary-subtle rounded-pill fs-6 px-3">
                            PLAN DE PAGO
                        </span>
                        <EtiquetaTramite etiqueta={tramite.etiqueta} />
                    </div>
                    {cliente?.apellido && cliente?.nombre && (
                        <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                            <h5 className="text-secondary fw-semibold mb-0">
                                <PersonSearchIcon fontSize="small" className="me-1 mb-1" />
                                {apellidoNombre(cliente.apellido, cliente.nombre)}
                            </h5>
                            {cliente.telefonoPropio && (
                                <WhatsAppHeaderButton
                                    phone={cliente.telefonoPropio}
                                    clientName={`${cliente.nombre} ${cliente.apellido}`}
                                    onClick={() => window.dispatchEvent(
                                        new CustomEvent('openAdminSidebar', { detail: { tab: 'whatsapp' } })
                                    )}
                                />
                            )}
                        </div>
                    )}
                    <PanelUbicacionTramite tramite={tramite} onUpdated={setTramite} />
                </div>
                <div className="d-flex gap-2 mt-1 align-items-center flex-wrap">
                    <BotonGenerarCaratula
                        tipo="PLAN_PAGO"
                        idTramite={tramite.idTramite}
                        onGenerado={recargarArchivos}
                    />
                    <button
                        className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill"
                        onClick={() => setMostrarModalTurno(true)}
                    >
                        <i className="bi bi-calendar-plus"></i> Crear turno
                    </button>
                    <button
                        className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill"
                        onClick={volverAtras}
                    >
                        <ArrowBackIcon fontSize="small" /> Volver
                    </button>
                </div>
            </div>

            <BannerEstadoFinal
                idTramite={tramite.idTramite}
                nombreEstadoActual={tramite.nombreEstadoActual}
            />

            {/* Estado + historial */}
            <div
                className="card shadow-sm border-0 rounded-4 p-4 mb-3"
                style={{ backgroundColor: '#f8f9fa', cursor: 'pointer', transition: 'all 0.2s ease' }}
                onClick={() => setModalHistorialAbierto(true)}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e9ecef'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#f8f9fa'; }}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                        <h5 className="fw-bold text-secondary mb-0">Estado</h5>
                        <span className="badge bg-success bg-opacity-10 text-success border border-success-subtle rounded-pill fs-6 px-3">
                            {tramite.nombreEstadoActual || 'Ingreso del Trámite'}
                        </span>
                        {tramite.fechaEstadoActual && (
                            <span className="text-muted small">
                                {new Date(tramite.fechaEstadoActual).toLocaleDateString('es-ES')}
                            </span>
                        )}
                    </div>
                    <span className="text-primary">
                        <i className="bi bi-arrow-right-circle me-1"></i>Ver historial
                    </span>
                </div>
            </div>

            {/* Nota editable de comentarios (con firma, igual que ART/RTI/Jubilación/PUAM) */}
            <NotaComentario
                valor={tramite.comentarios || ''}
                onGuardar={handleGuardarComentario}
                label="Comentarios del Trámite de Plan de Pago"
                color="blue"
                nombreUsuario={user?.nombre || ''}
            />

            {/* Cobranza del trámite: desplegable, debajo del estado y los comentarios */}
            <SeccionCobranzaTramite tramite={tramite} />

            {/* Con el turno ANSES ya resuelto (el plan ingresó), lo primero son los módulos del plan
                (aportes, compras, apertura) y el turno queda debajo como registro. Mientras no tiene
                resultado, el turno va primero: es lo que hay que hacer. Se mueven los paneles y no
                la tarjeta, para que el turno no se vuelva a cargar. */}
            {turnoConResultado && modulosPlanPago}

            {/* Turno en ANSES: hito propio del trámite. Al cargarlo se genera la citación al
                estudio en el turnero y el evento de agenda. */}
            <TarjetaTurnoAnses
                idTramite={tramite.idTramite}
                cuilCliente={tramite.idCliente || cliente.cuil}
                nombreArea="este trámite de Plan de Pago"
                ofreceResolucion={false}
                nombreEstadoActual={tramite.nombreEstadoActual}
                onCambio={refrescarPorTurnoAnses}
                onEstadoCambiado={refrescarPorTurnoAnses}
                onResultadoRegistrado={setTurnoConResultado}
            />

            {!turnoConResultado && modulosPlanPago}
            {enSeguimientoDeExpediente(tramite.nombreEstadoActual) && <ExpedientesAnsesTramite idTramite={tramite.idTramite} />}

            {/* Eventos del Trámite */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="card shadow-lg border-0 rounded-4 p-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="fw-bold text-primary mb-0">Eventos del Trámite</h4>
                            <button
                                className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill fw-semibold"
                                onClick={() => {
                                    const hoy = new Date();
                                    setFechaSeleccionadaEvento(new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()));
                                    setMostrarModalEvento(true);
                                }}
                            >
                                <span style={{ fontSize: '1.2rem' }}>+</span> Crear Evento
                            </button>
                        </div>
                        {cargandoEventos ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status"></div>
                                <p className="mt-2 text-muted">Cargando eventos...</p>
                            </div>
                        ) : eventos.length === 0 ? (
                            <div className="alert alert-info border-0 rounded-3 text-center">
                                <p className="mb-0">No hay eventos registrados para este trámite</p>
                            </div>
                        ) : (
                            <div className="row g-3">
                                {eventos.map(evento => (
                                    <div key={evento.idEvento} className="col-md-6 col-lg-4">
                                        <div className="card h-100 border rounded-3 p-3 shadow-sm">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <h6 className="fw-bold text-primary mb-0">{evento.titulo}</h6>
                                                {evento.tipoEvento && <span className="badge bg-primary rounded-pill">{evento.tipoEvento}</span>}
                                            </div>
                                            {evento.descripcion && <p className="text-muted small mb-2">{evento.descripcion}</p>}
                                            <div className="mt-auto">
                                                <div className="d-flex align-items-center gap-2 mb-1">
                                                    <small className="text-muted">📅</small>
                                                    <small className="fw-semibold">{formatearFechaEvento(evento.fecha)}</small>
                                                </div>
                                                {evento.todoElDia ? (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <small className="text-muted">🕐</small>
                                                        <small className="text-success fw-semibold">Todo el día</small>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <small className="text-muted">🕐</small>
                                                        <small>{evento.horaInicio} - {evento.horaFin}</small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Info del Trámite + Info del Cliente */}
            <div className="row g-4">
                <div className="col-lg-6">
                    <div className="card shadow-lg border-0 rounded-4 p-4 h-100">
                        <h4 className="fw-bold text-primary mb-3">
                            <i className="bi bi-cash-coin me-2"></i>
                            Información del Trámite
                        </h4>
                        {!editMode ? (
                            <>
                                <p><strong>Organismo:</strong> {tramite.organismo === 'ANSES' ? 'ANSES' : tramite.organismo === 'PROVINCIA' ? 'Provincia' : 'Sin especificar'}</p>
                                <p><strong>Alta de Monotributo realizada:</strong> {tramite.altaMonotributoRealizada ? 'Sí' : 'No'}</p>
                                <p><strong>Aporta en provincia no transferida:</strong> {tramite.aportesProvinciaNoTransferida ? 'Sí' : 'No'}</p>
                                {tramite.etiqueta && <p><strong>Etiqueta:</strong> {tramite.etiqueta}</p>}
                                <ChecklistTramite tramite={tramite} onActualizado={recargarTramite} />
                                <TarjetaCobroTramite
                                    tramite={tramite}
                                    onPactoGenerado={() => Promise.all([recargarTramite(), recargarArchivos()])}
                                />
                                <div className="mt-3 d-flex gap-2 flex-wrap">
                                    <button className="btn btn-outline-primary rounded-pill px-4 fw-semibold" onClick={handleModificar}>
                                        <i className="bi bi-pencil me-2"></i>Editar datos
                                    </button>
                                    <BotonCancelarReactivarTramite tramite={tramite} onActualizado={recargarTramite} />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Organismo</label>
                                    <input className="form-control" value="ANSES" disabled readOnly
                                        style={{ color: '#000', opacity: 1 }} />
                                </div>
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" id="edit-alta-mtb"
                                        checked={!!tramiteEdit.altaMonotributoRealizada}
                                        onChange={(e) => setTramiteEdit(p => ({ ...p, altaMonotributoRealizada: e.target.checked }))} />
                                    <label className="form-check-label" htmlFor="edit-alta-mtb">Alta de Monotributo realizada</label>
                                </div>
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" id="edit-aportes-provincia"
                                        checked={!!tramiteEdit.aportesProvinciaNoTransferida}
                                        onChange={(e) => setTramiteEdit(p => ({ ...p, aportesProvinciaNoTransferida: e.target.checked }))} />
                                    <label className="form-check-label" htmlFor="edit-aportes-provincia">Aporta en provincia que no transfirió su caja a Nación</label>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Etiqueta</label>
                                    <input type="text" className="form-control" value={tramiteEdit.etiqueta || ''}
                                        onChange={(e) => setTramiteEdit(p => ({ ...p, etiqueta: e.target.value }))} />
                                </div>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-primary rounded-pill px-4 fw-semibold" onClick={() => handleGuardarDatos()} disabled={guardandoDatos}>
                                        {guardandoDatos ? <span className="spinner-border spinner-border-sm" role="status"></span> : <><i className="bi bi-check-circle me-2"></i>Guardar</>}
                                    </button>
                                    <button className="btn btn-outline-secondary rounded-pill px-4" onClick={() => setEditMode(false)}>Cancelar</button>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="card shadow-lg border-0 rounded-4 p-4 h-100">
                        <h4 className="fw-bold mb-3" style={{ color: '#6c757d' }}>Información del Cliente</h4>
                        <p><strong>CUIL:</strong> {cliente.cuil || 'N/A'}</p>
                        <p><strong>Nombre:</strong> {cliente.nombre || 'N/A'}</p>
                        <p><strong>Apellido:</strong> {cliente.apellido || 'N/A'}</p>
                        <p><strong>Oficio / Actividad:</strong> {cliente.oficio || 'N/A'}</p>
                        <p><strong>Teléfono:</strong> {cliente.telefonoPropio || 'N/A'}</p>
                        {cliente.fechaNacimiento && (
                            <p><strong>Fecha de nacimiento:</strong> {new Date(cliente.fechaNacimiento).toLocaleDateString('es-ES')}</p>
                        )}
                        {cliente.cuil && (
                            <div className="mt-3 d-flex justify-content-center">
                                <button
                                    className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                    onClick={() => verDetalleCliente(cliente.cuil)}
                                >
                                    <PersonSearchIcon fontSize="medium" /> Ver Detalle del Cliente
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Expedientes de ANSES: acá, debajo de los datos del trámite y del cliente; arriba solo
                mientras el trámite está en "Seguimiento de Expediente". */}
            {!enSeguimientoDeExpediente(tramite.nombreEstadoActual) && <ExpedientesAnsesTramite idTramite={tramite.idTramite} />}

            {/* Hijos */}
            {hijos.length > 0 && (
                <div className="row g-4 mt-1">
                    <div className="col-12">
                        <div className="card shadow-lg border-0 rounded-4 p-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="fw-bold text-primary mb-0"><i className="bi bi-people me-2"></i>Hijos</h4>
                                <span className={`badge ${claseBadgeContador(hijos.filter(h => h.actaPresentada).length, hijos.length)}`}>
                                    {hijos.filter(h => h.actaPresentada).length}/{hijos.length} actas
                                </span>
                            </div>
                            <div className="row g-3">
                                {hijos.map(h => (
                                    <div key={h.idHijo} className="col-md-6">
                                        <div className="border rounded-4 p-3 h-100" style={{ background: '#f8fafc' }}>
                                            <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                                                <div>
                                                    <h6 className="fw-bold text-primary mb-0">{h.nombre || 'Sin nombre'}</h6>
                                                    <small className="text-muted">Edad: {calcularEdad(h.fechaNacimiento) || '—'}</small>
                                                </div>
                                                <div className="d-flex gap-1 flex-wrap justify-content-end">
                                                    {h.tieneAuh && <span className="badge rounded-pill" style={{ background: '#dbeafe', color: '#1e40af' }}>AUH</span>}
                                                    {h.tieneCud && <span className="badge rounded-pill" style={{ background: '#ede9fe', color: '#5b21b6' }}>CUD</span>}
                                                    {h.esAdoptado && <span className="badge rounded-pill" style={{ background: '#fef3c7', color: '#92400e' }}>Adoptado/a</span>}
                                                </div>
                                            </div>
                                            <hr className="my-2" />
                                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                <div className="form-check mb-0">
                                                    <input className="form-check-input" type="checkbox" id={`acta-${h.idHijo}`}
                                                        checked={!!h.actaPresentada} disabled={!!h.idArchivoActa}
                                                        onChange={() => togglePresentadaActa(h)} />
                                                    <label className="form-check-label small" htmlFor={`acta-${h.idHijo}`}
                                                        style={{ textDecoration: h.actaPresentada ? 'line-through' : 'none', color: h.actaPresentada ? '#6c757d' : 'inherit' }}>
                                                        Acta de nacimiento
                                                    </label>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    {h.idArchivoActa ? (
                                                        <>
                                                            <button className="btn btn-sm btn-outline-primary rounded-pill"
                                                                onClick={() => descargarPorId(h.idArchivoActa)}
                                                                title={nombrePorId[h.idArchivoActa] || 'Descargar'}>
                                                                <i className="bi bi-download me-1"></i>
                                                                {nombrePorId[h.idArchivoActa] || 'Descargar'}
                                                            </button>
                                                            <button className="btn btn-sm btn-link text-danger p-0" title="Quitar adjunto"
                                                                onClick={() => quitarActaAdjunta(h)}>
                                                                <i className="bi bi-x-circle"></i>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <label className="btn btn-sm btn-outline-secondary rounded-pill mb-0">
                                                            {subiendoActaHijo === h.idHijo
                                                                ? <span className="spinner-border spinner-border-sm" role="status"></span>
                                                                : <><i className="bi bi-paperclip me-1"></i>Adjuntar</>}
                                                            <input type="file" accept="application/pdf" hidden
                                                                onChange={(e) => adjuntarActa(h, e.target.files[0])} />
                                                        </label>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Reconocimientos de Servicios vinculados a este Plan de Pago */}
            <CardReconocimientosServicios idTramitePadre={tramite.idTramite} cliente={cliente} />

            {/* Trámites relacionados del cliente: Jubilaciones detectadas por CUIL (sin FK) */}
            <PanelTramitesRelacionados
                titulo="Trámites relacionados del cliente"
                icono="bi-diagram-3"
                tramites={jubilacionesRelacionadas}
                cargando={cargandoRelacionados}
                textoVacio="Este cliente todavía no tiene una Jubilación cargada."
                accion={cliente.cuil && (
                    jubilacionesRelacionadas.length > 0 ? (
                        <span className="badge bg-secondary bg-opacity-10 text-secondary border border-secondary-subtle rounded-pill px-3 py-2">
                            <i className="bi bi-info-circle me-1"></i>Ya tiene una jubilación
                        </span>
                    ) : (
                        <button
                            className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2 rounded-pill fw-semibold"
                            onClick={() => navigate(rutaIniciarTramite('JUBILACION', cliente.cuil))}
                        >
                            <span style={{ fontSize: '1.1rem' }}>+</span> Crear jubilación
                        </button>
                    )
                )}
            />

            {/* Documentación del Trámite: checklist de formularios + otros documentos (un solo lugar) */}
            <div className="row g-4 mt-1">
                <div className="col-12">
                    <div className="card shadow-lg border-0 rounded-4 p-4">
                        <h4 className="fw-bold text-primary mb-3"><i className="bi bi-folder2-open me-2"></i>Documentación del Trámite</h4>

                        {/* Formularios requeridos */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold text-secondary mb-0"><i className="bi bi-check2-square me-2"></i>Formularios requeridos</h6>
                            <span className={`badge ${claseBadgeContador(formularios.filter(f => f.presentado).length, formularios.length)}`}>{formularios.filter(f => f.presentado).length}/{formularios.length}</span>
                        </div>
                        {formularios.length === 0 ? (
                            <div className="alert alert-info border-0 rounded-3 text-center mb-0">
                                <p className="mb-0">No hay formularios en el checklist.</p>
                            </div>
                        ) : (
                            <ul className="list-group list-group-flush">
                                {formularios.map(f => (
                                    <li key={f.id} className="list-group-item d-flex justify-content-between align-items-center flex-wrap gap-2 px-0">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id={`chk-${f.id}`}
                                                checked={!!f.presentado} disabled={!!f.idArchivo}
                                                onChange={() => togglePresentado(f)} />
                                            <label className="form-check-label" htmlFor={`chk-${f.id}`}
                                                style={{ textDecoration: f.presentado ? 'line-through' : 'none', color: f.presentado ? '#6c757d' : 'inherit' }}>
                                                {f.nombre}
                                            </label>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            {f.idArchivo ? (
                                                <>
                                                    <button className="btn btn-sm btn-outline-primary rounded-pill"
                                                        onClick={() => descargarPorId(f.idArchivo)}
                                                        title={nombrePorId[f.idArchivo] || 'Descargar'}>
                                                        <i className="bi bi-download me-1"></i>
                                                        {nombrePorId[f.idArchivo] || 'Descargar'}
                                                    </button>
                                                    <button className="btn btn-sm btn-link text-danger p-0" title="Quitar adjunto"
                                                        onClick={() => quitarAdjunto(f)}>
                                                        <i className="bi bi-x-circle"></i>
                                                    </button>
                                                </>
                                            ) : (
                                                <label className="btn btn-sm btn-outline-secondary rounded-pill mb-0">
                                                    {subiendoItem === f.id
                                                        ? <span className="spinner-border spinner-border-sm" role="status"></span>
                                                        : <><i className="bi bi-paperclip me-1"></i>Adjuntar</>}
                                                    <input type="file" accept="application/pdf" hidden
                                                        onChange={(e) => adjuntarArchivo(f, e.target.files[0])} />
                                                </label>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}

                        <hr className="my-4" />

                        {/* Otros documentos (no vinculados a un formulario) */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold text-secondary mb-0"><i className="bi bi-paperclip me-2"></i>Otros documentos</h6>
                            <label className="btn btn-sm btn-outline-primary rounded-pill mb-0">
                                {subiendoGeneral
                                    ? <span className="spinner-border spinner-border-sm" role="status"></span>
                                    : <><i className="bi bi-cloud-upload me-1"></i>Subir archivo</>}
                                <input type="file" hidden onChange={(e) => { subirGeneral(e.target.files[0]); e.target.value = ''; }} />
                            </label>
                        </div>
                        {archivosOtros.length === 0 ? (
                            <p className="text-muted fst-italic mb-0">No hay otros documentos cargados.</p>
                        ) : (
                            <div className="d-flex flex-column gap-2">
                                {archivosOtros.map(a => (
                                    <div key={a.idArchivo} className="d-flex align-items-center justify-content-between border rounded-3 px-3 py-2">
                                        <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
                                            <i className="bi bi-file-earmark-text text-primary" style={{ fontSize: '1.25rem' }}></i>
                                            <div style={{ minWidth: 0 }}>
                                                <div className="fw-semibold text-truncate" style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                    onClick={() => descargarPorId(a.idArchivo)} title={a.nombre}>
                                                    {a.nombre}
                                                </div>
                                                <small className="text-muted">{formatTamano(a.tamaño)}</small>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-1 flex-shrink-0">
                                            <button className="btn btn-sm" style={{ color: '#0056b3', border: 'none' }} title="Descargar"
                                                onClick={() => descargarPorId(a.idArchivo)}>
                                                <i className="bi bi-download"></i>
                                            </button>
                                            <button className="btn btn-sm" style={{ color: '#dc3545', border: 'none' }} title="Eliminar"
                                                onClick={() => eliminarGeneral(a.idArchivo)}>
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Modal crear evento */}
            <CrearEventoModal
                isOpen={mostrarModalEvento}
                onClose={() => setMostrarModalEvento(false)}
                onSave={handleGuardarEvento}
                selectedDate={fechaSeleccionadaEvento}
                idTramite={idTramite}
            />

            {/* Acciones irreversibles (cambiar tipo / eliminar definitivamente).
                El propio panel decide si mostrarse segun el rol. */}
            <PanelAccionesAvanzadasTramite
                idTramite={tramite?.idTramite}
                tipoTramite="PLAN_PAGO"
            />

            {/* Modal historial de estados (ámbito PLAN_PAGO) */}
            <HistorialTramite
                isOpen={modalHistorialAbierto}
                onClose={() => setModalHistorialAbierto(false)}
                idTramite={idTramite}
                onEstadoCambiado={recargarTramite}
                ambitoFiltro="PLAN_PAGO"
            />

            {/* Modal crear turno (reutiliza el turnero de Recepción, prellenado con el cliente) */}
            {mostrarModalTurno && (
                <div className={turneroStyles.overlay} onClick={() => setMostrarModalTurno(false)}>
                    <div className={turneroStyles.contenidoModal} onClick={(e) => e.stopPropagation()}>
                        <ModalCrearTurno
                            celdaSel={null}
                            valoresIniciales={{
                                nombre: cliente.nombre || '',
                                apellido: cliente.apellido || '',
                                cuil: cliente.cuil || '',
                                telefono: cliente.telefonoPropio || '',
                                tipoTramite: 'PLAN_PAGO',
                            }}
                            onCerrar={() => setMostrarModalTurno(false)}
                            onCreado={() => { setMostrarModalTurno(false); toast.success('Turno creado correctamente'); }}
                        />
                    </div>
                </div>
            )}

            <CustomModal {...modalState} onHide={hideModal} />
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />
            <FeedbackButton tramite={tramite} />
        </div>
    );
}

export default VistaDetalladaTramitePlanPago;
